import React from 'react';

import * as ROUTES from '../Constants/routes';

import { Nav, Navbar } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
 
const Navigation = () => {
    return (
      <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
        <img alt="logo" width="50" height="50" src="../../favicon.ico" />
        <Navbar.Brand href={ROUTES.CUSTOM_HOME}>Envato</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href={ROUTES.HOME}>Home</Nav.Link>
            <Nav.Link href={ROUTES.ABOUT}>About</Nav.Link>
            <Nav.Link href={ROUTES.SUPPORTUS}>Support Us</Nav.Link>
            <Nav.Link href={ROUTES.SCHEDULE}>Schedule</Nav.Link>
          </Nav>
          <Nav>
            <span style={{ color: "#807A79" }}>
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="white-text mr-2"
              />
              Houston, TX &#x2022; <i>Help India Breathe</i>
            </span>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
}
 
export default Navigation;